import { useState, useEffect, useCallback } from 'react';

const DARK_MODE_KEY = 'docscout-dark-mode';

export function useDarkMode(): {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
} {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem(DARK_MODE_KEY) === 'true';
  });

  useEffect(() => {
    localStorage.setItem(DARK_MODE_KEY, isDarkMode.toString());
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  const toggleDarkMode = useCallback(() => {
    setIsDarkMode(prev => !prev);
  }, []);

  return { isDarkMode, toggleDarkMode };
}
